import { render } from "./autoLogin.vue?vue&type=template&id=636919c2&scoped=true"
import script from "./autoLogin.vue?vue&type=script&lang=js"
export * from "./autoLogin.vue?vue&type=script&lang=js"

import "./autoLogin.vue?vue&type=style&index=0&id=636919c2&lang=scss&scoped=true"

import exportComponent from "E:\\javaproject\\jingniu\\pes-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636919c2"]])

export default __exports__